import React from "react";
import "./Ceodb.scss";
import InsightSpeedometer from "../InsightMenu/InsightSpeedometer";

const StatementWisePreview = () => {
    return (
        <div className="statement-wise-page">

            {/* TOP GAUGES */}
            <div className="gauge-row">
                <InsightSpeedometer />
                <InsightSpeedometer />
            </div>

            {/* MIDDLE CONTENT */}
            <div className="content-row">

                {/* LEFT – STATEMENT SCORES */}
                <div className="statement-card">
                    <h3 className="section-title">Respect</h3>

                    <StackBar
                        label="People here are treated fairly regardless of their gender."
                        green="48.66"
                        yellow="16.89"
                        red="34.46"
                    />

                    <StackBar
                        label="I am able to take time off from work when I think it's necessary."
                        green="41.89"
                        yellow="18.24"
                        red="39.86"
                    />
                </div>

                {/* RIGHT – KEY TRENDS */}
                <div className="trend-card">
                    <div className="trend-header">
                        <h3>Key Trends</h3>
                        <select>
                            <option>Location</option>
                        </select>
                    </div>

                    <div className="trend-list">
                        <TrendRow name="Delhi" score="59" delta="+59" positive />
                        <TrendRow name="Mumbai" score="37" delta="+4" positive />
                        <TrendRow name="Pune" score="65" delta="-6" />
                        <TrendRow name="Nagpur" score="38" delta="+21" positive />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default StatementWisePreview;

/* ---------------- SUB COMPONENTS ---------------- */

const StackBar = ({ label, green, yellow, red }) => (
    <div className="stack-item">
        <div className="stack-label">
            <span>{label}</span>
            <span className="respondent">Respondent: 148</span>
            <button className="action-btn">Action</button>
        </div>

        <div className="stack-bar">
            <div className="green" style={{ width: `${green}%` }}>{green}</div>
            <div className="yellow" style={{ width: `${yellow}%` }}>{yellow}</div>
            <div className="red" style={{ width: `${red}%` }}>{red}</div>
        </div>
    </div>
);

const TrendRow = ({ name, score, delta, positive }) => (
    <div className="trend-row">
        <span>{name}</span>
        <span className={positive ? "positive" : "negative"}>
            {score} ({delta})
        </span>
    </div>
);
